var assign = require('lodash/assign');

/*
 * Cheerio default options
 */

exports.default = {
  withDomLvl1: true,
  normalizeWhitespace: false,
  xml: false,
  decodeEntities: true
};

exports.flatten = function(options) {
  return options && options.xml ? assign({xmlMode: true}, options.xml) : options;
};


//////////////////
// WEBPACK FOOTER
// ./~/cheerio/lib/options.js
// module id = 295
// module chunks = 168707334958949